<template>
	<div>
		<app-app-header :title="$t('view.team.title')" :color="$config.public.colors.primary" v-model="indexStore.isHeaderVisible"/>

		<app-content>
			<page-content xs-full sm-full md-full lg-full>
				<div class="bg-white">
					<feature-screen hide-title-on-mobile image="/views/team/spoferan-team.jpg" lang-prefix="view.team"/>

					<page-content>
						<feature-section v-for="(admin, adminIndex) in admins" :key="admin.id" right cols="8" :title="`${admin.display_name} (${admin.age})`" :subtitle="admin.job"
										 :description="admin.description" :divided="adminIndex < admins.length - 1">
							<nuxt-link :to="$web('users.show', admin._key)">
								<cdn-image :src="admin.avatar_thumbnail" :alt="admin.display_name" :size="{width: 250, ratio: 1}" rounded class="shadow"/>
							</nuxt-link>
						</feature-section>
					</page-content>
				</div>
			</page-content>
		</app-content>
	</div>
</template>

<script setup lang="ts">
import {useIndexStore} from "../../store";

const {t} = useI18n();
const {$web, $image, $api} = useNuxtApp();
const indexStore = useIndexStore();

const {data: admins} = await useApiFetch('/v1/admins', {
	guest: true,
	params: {
		active: true
	}
})

useMeta({
	title: t('view.team.title'),
	description: t('view.team.description'),
	image: $image.format('/views/team/spoferan-team.jpg', {width: 1200, height: 1200}),
	noIndex: true
})

</script>

